import { definePage, schema } from '@go-beyond/schema'

export const page = definePage({
  props: schema.object({
    appURL: schema.string(),
    signInURL: schema.string(),
  }),
})
